<template>
  <Starfield>
    <iColumn width="fill" gap="standard">
      <AppHeader />
      <iColumn width="fill" gap="none">
        <Panel v-if="panelTitle" :title="panelTitle">
          <AppPage
            :app-name="appName"
            :page-name="pageName"
            :contexts="contexts"
            :entities="entities"
          />
        </Panel>
        <AppPage
          v-else
          :app-name="appName"
          :page-name="pageName"
          :contexts="contexts"
          :entities="entities"
        />
      </iColumn>
    </iColumn>
  </Starfield>
</template>

<script>
import AppPage from "@bloglovin/inspire-engine/Pages/AppPage";
import Starfield from "@/components/Starfield";
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";

// Deployatron's chrome wrapper for engine-rendered pages. Inspire
// apps (queue, project_management, chat) declare bare page
// components with no host chrome — the engine renders them inside
// AppPage. This wrapper composes the host's Starfield + AppHeader
// around AppPage so every engine-rendered route gets the deployatron
// look without each app having to know about it.
//
// `appName`, `pageName`, `contexts`, and `entities` are forwarded
// through unchanged. AppHeader carries only the Starjedi brand and
// the R2-D2 dropdown — no breadcrumbs / nav, since pages render
// their own navigation if they need it.
//
// `panelTitle` is an opt-in prop. When the host controller wants
// the page rendered inside the deployatron panel chrome (yellow
// border + Starjedi legend, matching the queue panel's look), it
// passes a title string; this wrapper inserts a <Panel> around the
// engine's AppPage. Bare pages (e.g. project edit) leave it unset
// and render directly.
//
// The body wrapper is a `width="fill"` iColumn rather than a plain
// `<div>`. The fill width matters because the outer iColumn's
// align-items resolves to `flex-start`, which would otherwise
// collapse a child with no explicit width to its widest content.
// iColumn also supplies the v-bind-CSS-var safety the parent's
// child traversal needs (a bare v-if/v-else under iColumn can
// produce null VNodes and crash the walker).
export default {
  name: "DeployatronAppPage",
  components: { Starfield, AppHeader, AppPage, Panel },
  props: {
    appName: {
      type: String,
      required: true,
    },
    pageName: {
      type: String,
      required: false,
      default: "",
    },
    contexts: {
      type: Object,
      required: true,
    },
    entities: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    panelTitle: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
